import { Injectable, signal } from '@angular/core';

type RoleName = 'admin' | 'profesional' | 'alumno' | string;

@Injectable({ providedIn: 'root' })
export class SessionService {
  private ACCESS = 'access-token';
  private REFRESH = 'refresh-token';
  private USER = 'user';
  private ROLE = 'role';
  private PROFESIONAL_DATA = 'profesionalData';

  // Signal para el usuario actual
  private userSignal = signal<any | null>(this.getUserFromStorage());

  // Exponer el signal como readonly
  public user = this.userSignal.asReadonly();

  private getUserFromStorage(): any | null {
    const raw = sessionStorage.getItem(this.USER);
    return raw ? JSON.parse(raw) : null;
  }

  setSession(params: {
    accessToken: string;
    refreshToken?: string;
    user: any;
    role: string;
  }) {
    sessionStorage.setItem(this.ACCESS, params.accessToken);
    if (params.refreshToken)
      sessionStorage.setItem(this.REFRESH, params.refreshToken);
    sessionStorage.setItem(this.USER, JSON.stringify(params.user));
    sessionStorage.setItem(this.ROLE, params.role);
    // Actualizar el signal
    this.userSignal.set(params.user);
  }

  // ✅ nuevo: actualizar SOLO tokens (para refresh)
  updateTokens(accessToken: string, refreshToken?: string) {
    sessionStorage.setItem(this.ACCESS, accessToken);
    if (refreshToken) sessionStorage.setItem(this.REFRESH, refreshToken);
  }

  clearSession() {
    sessionStorage.removeItem(this.ACCESS);
    sessionStorage.removeItem(this.REFRESH);
    sessionStorage.removeItem(this.USER);
    sessionStorage.removeItem(this.ROLE);
    sessionStorage.removeItem(this.PROFESIONAL_DATA);
    // Limpiar el signal
    this.userSignal.set(null);
  }

  getAccessToken(): string | null {
    return sessionStorage.getItem(this.ACCESS);
  }

  getRefreshToken(): string | null {
    return sessionStorage.getItem(this.REFRESH);
  }

  getRole(): string | null {
    return sessionStorage.getItem(this.ROLE);
  }

  getUser(): any | null {
    const raw = sessionStorage.getItem(this.USER);
    return raw ? JSON.parse(raw) : null;
  }

  getProfesionalData(): any | null {
    const raw = sessionStorage.getItem(this.PROFESIONAL_DATA);
    return raw ? JSON.parse(raw) : null;
  }

  setProfesionalData(professionalData: any): void {
    sessionStorage.setItem(
      this.PROFESIONAL_DATA,
      JSON.stringify(professionalData),
    );
  }

  setUser(user: any): void {
    sessionStorage.setItem(this.USER, JSON.stringify(user));
    // Actualizar el signal
    this.userSignal.set(user);
  }
}
